import React, { createContext, useContext, useEffect, useState } from "react";
import { hitApi } from "../utils/apiCall";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(null); // null = loading
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkLogin = async () => {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        setIsLoggedIn(false);
        setLoading(false);
        return;
      }

      try {
        const res = await hitApi(
          "permission/permission",
          "getMenuDetails",
          new FormData()
        );
        if (res.code === 403) {
          localStorage.clear();
          setIsLoggedIn(false);
        } else {
          setIsLoggedIn(true);
        }
      } catch (err) {
        console.error("Auth check failed", err);
        setIsLoggedIn(false);
      } finally {
        setLoading(false);
      }
    };

    checkLogin();
  }, []);

  return (
    <AuthContext.Provider value={{ isLoggedIn, loading, setIsLoggedIn }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
